(()=>{
  let last=-1,frame=0;
  const update=()=>{
    frame=0;
    const preview=document.querySelector('#PBarNextFrameWrapper,#preview-bar-iframe');
    const rect=preview?.getBoundingClientRect();
    const offset=rect&&rect.height&&getComputedStyle(preview).display!=='none'?Math.max(0,innerHeight-rect.top):0;
    if(last!==offset){last=offset;document.documentElement.style.setProperty('--bbc-privacy-preview-offset',offset+'px');}
  };
  const schedule=()=>{if(!frame)frame=requestAnimationFrame(update);};
  new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
  window.addEventListener('resize',schedule,{passive:true});
  window.visualViewport?.addEventListener('resize',schedule,{passive:true});
  schedule();
})();